export default {
  forms: [
    {
      id: "shiftInduction",
      title: "Shift Induction"
    },
    {
      id: "benefitsDeclaration",
      title: "Benefits Declaration"
    },
    {
      id: "driverDeclaration",
      title: "Driver Declaration"
    },
    {
      id: "onboardingQuestionsStage1",
      title: "Onboarding Questions (Stage 1)"
    },
    {
      id: "inductionSignoff",
      title: "Induction Signoff"
    },
    {
      id: "dvlaCheckAndSignature",
      title: "DVLA Check"
    }
  ].sort((a, b) => a.title.localeCompare(b.title))
};
